import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slots', 'checkbox']
  static values = { comparadorType: String }

  // La cookie es común a todos los comparadores y cada hueco va como `<comparador>_<id>`. Si lo elegido es
  // de otro comparador, se vacía. El nombre se compara entero: con `includes`, lo elegido en `tarifas_luz`
  // pasaba por propio en `tarifas` (telefonía).
  initialize () {
    const delComparador = (slot) => slot.slice(0, slot.lastIndexOf('_')) === this.comparadorName

    if (!Array.from(this.selected.keys()).some(delComparador)) {
      this.clear()
    }
  }

  connect () {
    this.refresh()
    document.addEventListener('turbo:frame-load', this.refresh.bind(this))
  }

  refresh () {
    const defaultItem = this.defaultItem

    let selectedValues = Array.from(this.selected.values())

    for (let i = 0; i < 4; i++) {
      let slogLogo = this.logos[i]
      const slotTitle = slogLogo.closest('div').querySelector('small')

      if (selectedValues[i]) {
        slogLogo.src = selectedValues[i].src
        slogLogo.alt = selectedValues[i].alt
        slogLogo.title = selectedValues[i].title

        slotTitle.textContent = selectedValues[i].alt
      } else {
        slogLogo.src = defaultItem.src
        slogLogo.alt = defaultItem.title
        slogLogo.title = defaultItem.title

        slotTitle.textContent = defaultItem.title
      }
    }

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.disabled = this.selected.size === 4
      checkbox.checked = false

      if (selectedValues.map((e) => e.value).includes(checkbox.value)) {
        checkbox.disabled = false
        checkbox.checked = true
      }
    })
  }

  add (value) {
    const item = document.querySelector('#img_' + value)

    this.selected.set([this.comparadorName, value].join('_'), {
      src: item.src,
      alt: item.alt || 'Listo para comparar',
      title: item.title || 'Listo para comparar',
      value: value
    })

    this.refresh()
  }

  remove (value) {
    this.selected.delete([this.comparadorName, value].join('_'))
    this.refresh()
  }

  checkboxOnChange (event) {
    (event.target.checked) ? this.add(event.target.value) : this.remove(event.target.value)
  }

  clear () {
    this.selected.clear()
    this.refresh()
  }

  submit (event) {
    if (this.selected.size < 2) return
    var params = Array.from(this.selected.values()).map(a => a.value).reduce((a,b) => a + '/' + b)
    window.location.replace(this.slotsTarget.dataset.url + '/' + params)
  }

  get defaultItem () {
    let defaultItem = document.createElement('img')

    // SVG propio: via.placeholder.com dejó de responder el 7-oct-2026 y bloqueaba la carga de la página
    defaultItem.src = 'data:image/svg+xml,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="150" height="40" viewBox="0 0 150 40">' +
      '<rect width="100%" height="100%" fill="#d9d9d9"/>' +
      '<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" ' +
      'font-size="10" fill="#737373">Disponible</text></svg>'
    )
    defaultItem.title = 'Selecciona uno'

    return defaultItem
  }

  get logos () {
    return this.slotsTarget.querySelectorAll('img')
  }

  get comparadorName () {
    return this.comparadorTypeValue || window.location.pathname.split('/').pop()
  }

  get selected () {
    const that = this

    // We return a proxy that will call the setter any time the map of selected products changes in any way.
    // Thus, the state of the comparador is always synced in memory, DOM and the cookie.
    return new Proxy(new Map(JSON.parse(this.slotsTarget.dataset.selected || '[]')), {
      get (target, trapName) {
        if (['size', 'target'].includes(trapName)) return target[trapName]

        return function (...args) {
          const trapResult = target[trapName](...args)
          that.selected = target
          return trapResult
        }
      }
    })
  }

  set selected (value) {
    Cookies.set('comparadores', JSON.stringify(Array.from(value)))
    this.slotsTarget.dataset.selected = JSON.stringify(Array.from(value))
  }
}
